import React from "react";
import * as Styles from "./buttonMenu.style";

interface ButtonMenuI {
  onClick?: () => void;
  content: string;
  icon?: any;
  isSelected: boolean;
}

export const ButtonMenu = (props: ButtonMenuI) => {
  return (
    <Styles.Container onClick={props.onClick} isSelected={props.isSelected}>
      {props?.icon}
      {props.content}
    </Styles.Container>
  );
};
